import PopupNotification from "components/Blocks/PopupNotification/PopupNotification";

export default PopupNotification;
